import axios from 'axios';
import instanceConfig from './instanceConfig';
import url from './url';

let portal = 'Presselounge';
let lang = 'de';

let fetched = false;
let wordings = {};

const get = function() {
  if (fetched) {
    return Promise.resolve(wordings);
  }

  return new Promise((resolve, reject) => {
    instanceConfig
      .get()
      .then(fetchedConfig => {
        resolve(
          axios
            .get(url.randomize(fetchedConfig['wordings-url']))
            .then(response => {
              fetched = true;
              wordings = response.data;
              return wordings;
            }),
        );
      })
      .catch(() => {
        fetched = true;
        reject();
      });
  });
};

function getLoaded() {
  return wordings;
}

export default get;

export { getLoaded };



// WEBPACK FOOTER //
// ./src/utils/wordings.js